// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"078007ef","203":"70277608","732":"3b14ac7e","977":"dbc3484d"}[chunkId] + ".chunk.js";
};